import React, { useState } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Upload01Icon, Delete02Icon, Tick01Icon } from '@hugeicons/core-free-icons';
import ResponsiveModal from './ResponsiveModal';
import Button from './Button';

const ReceiptUpload = ({ isOpen, onClose, onUpload }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleRemove = () => {
    setFile(null);
    setPreview(null);
  };

  const handleSubmit = () => {
    onUpload(file);
    onClose();
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} title="Upload Proof of Payment">
      <div className="py-6 space-y-6">
        {!file ? (
          <label className="flex flex-col items-center justify-center w-full h-64 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-[2rem] cursor-pointer bg-off-white/50 dark:bg-gray-800/50 hover:bg-off-white dark:hover:bg-gray-800 transition-colors">
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <div className="bg-soft-green/10 p-4 rounded-full mb-4 text-soft-green">
                <HugeiconsIcon icon={Upload01Icon} size={32} />
              </div>
              <p className="mb-2 text-sm text-charcoal dark:text-gray-300 font-bold">
                Click to upload receipt
              </p>
              <p className="text-xs text-muted-gray">SVG, PNG, JPG or GIF (MAX. 5MB)</p>
            </div>
            <input type="file" className="hidden" accept="image/*" onChange={handleFileChange} />
          </label>
        ) : (
          <div className="relative w-full h-64 rounded-[2rem] overflow-hidden border border-light-gray/20 dark:border-gray-700/20 shadow-sm">
            <img src={preview} alt="Receipt preview" className="w-full h-full object-cover" />
            <button 
              onClick={handleRemove}
              className="absolute top-4 right-4 p-2 bg-red-500/90 text-white rounded-full shadow-lg hover:bg-red-600 transition-colors backdrop-blur-sm"
            >
              <HugeiconsIcon icon={Delete02Icon} size={20} />
            </button>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-black/50 backdrop-blur-md text-white text-xs font-mono truncate">
              {file.name}
            </div>
          </div>
        )}

        <div className="flex flex-col gap-3">
          <Button 
            disabled={!file} 
            onClick={handleSubmit} 
            className="w-full py-4 rounded-2xl text-lg font-black shadow-float disabled:opacity-50"
          >
            <HugeiconsIcon icon={Tick01Icon} size={20} className="mr-2" />
            Confirm Upload
          </Button>
          <Button variant="secondary" onClick={onClose} className="w-full py-4 rounded-2xl font-bold">
            Cancel
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default ReceiptUpload;
